var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.currentParentTag(),
    _vm._b(
      { tag: "component" },
      "component",
      _vm.currentParentAttributes(),
      false
    ),
    [
      _vm._l(_vm.currentModel(), function (item, index) {
        return [
          _c(
            "with-root",
            { attrs: { show: _vm.renderCurrentChildTag(item) } },
            [
              _c(
                _vm.currentChildTag(item),
                _vm._b(
                  { tag: "component" },
                  "component",
                  _vm.currentChildAttributes(item),
                  false
                ),
                [
                  _vm._t("default", null, {
                    item: item,
                    index: index,
                    depth: _vm.depth,
                  }),
                  _vm._v(" "),
                  _vm.hasChildren(item)
                    ? _c("tree-view", {
                        attrs: {
                          model: item,
                          index: index,
                          depth: _vm.depth + 1,
                          "parent-tag": _vm.parentTag,
                          "parent-attributes": _vm.parentAttributes,
                          "render-child-tag": _vm.renderChildTag,
                          "child-tag": _vm.childTag,
                          "child-attributes": _vm.childAttributes,
                          "child-without-children-attributes":
                            _vm.childWithoutChildrenAttributes,
                          "child-with-children-attributes":
                            _vm.childWithChildrenAttributes,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (_) {
                                return [
                                  _vm._t("default", null, {
                                    item: _.item,
                                    index: _.index,
                                    depth: _.depth,
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }